// extracted by mini-css-extract-plugin
export default {"logo__box":"styles_logo__box__Vf2sn","footer__text":"styles_footer__text__+PEFj"};